export const ADMIN_BUTTON_VARIANTS = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GHOST: "ghost",
  SUCCESS: "success",
  DANGER: "danger",
});

export const ADMIN_BUTTON_SIZES = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
});

export const ADMIN_BUTTON_ICON_POSITIONS = Object.freeze({
  START: "start",
  END: "end",
});

export const ADMIN_BUTTON_TYPES = Object.freeze({
  BUTTON: "button",
  SUBMIT: "submit",
  RESET: "reset",
});

export const ADMIN_BUTTON_DEFAULTS = Object.freeze({
  VARIANT: ADMIN_BUTTON_VARIANTS.PRIMARY,
  SIZE: ADMIN_BUTTON_SIZES.MEDIUM,
  ICON_POSITION: ADMIN_BUTTON_ICON_POSITIONS.START,
  TYPE: ADMIN_BUTTON_TYPES.BUTTON,
});

export const ADMIN_BUTTON_VARIANT_VALUES = Object.freeze(
  Object.values(ADMIN_BUTTON_VARIANTS),
);

export const ADMIN_BUTTON_SIZE_VALUES = Object.freeze(
  Object.values(ADMIN_BUTTON_SIZES),
);

export const ADMIN_BUTTON_ICON_POSITION_VALUES = Object.freeze(
  Object.values(ADMIN_BUTTON_ICON_POSITIONS),
);

export const ADMIN_BUTTON_TYPE_VALUES = Object.freeze(
  Object.values(ADMIN_BUTTON_TYPES),
);
